import { HAS_ERRORS_FILTER_OPTIONS, SearchAndFilterTypes } from "src/constants";
import { ButtonFilter, CommonFilterProps, FormFilter } from "../CommonFilters";

export const ErrorFilter = (props: CommonFilterProps) => {
  return (
    <FormFilter label="Errors">
      <ButtonFilter
        filterKey={SearchAndFilterTypes.HasErrors}
        options={HAS_ERRORS_FILTER_OPTIONS}
        {...props}
      />
    </FormFilter>
  );
};
